var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("table", { staticClass: "table pricelist table-striped" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "tbody",
      _vm._l(_vm.seasonsWithPrice, function(season) {
        return _c("tr", { key: season.name }, [
          _c("td", [_vm._v(_vm._s(season.name))]),
          _vm._v(" "),
          _c(
            "td",
            _vm._l(season.seasonPeriods, function(p) {
              return _c("div", { key: p }, [
                _vm._v(
                  "\n                    " + _vm._s(p) + "\n                "
                )
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              "\n                ab " +
                _vm._s(season.price.toFixed(2).replace(".", ",")) +
                " €\n                "
            ),
            _c("br"),
            _vm._v(" "),
            _c("span", { staticClass: "small" }, [
              _vm._v("\n        Inklusive Endreinigung, Bettwäsche\n      ")
            ])
          ])
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Saison")]),
        _vm._v(" "),
        _c("th", [_vm._v("Zeiten")]),
        _vm._v(" "),
        _c("th", [
          _vm._v(
            "z.B. Preis für eine Woche inklusive Endreinigung und Bettwäsche für einen Gast"
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }